// src/context/EobFormContext.js
import { createContext, useContext } from 'react';

const EobFormContext = createContext(null);

export const useEobContext = () => {
  const context = useContext(EobFormContext);
  if (!context) throw new Error("useEobContext must be used within EobFormProvider");
  return context;
};

export default EobFormContext;
